import { render, staticRenderFns } from "./HistoryDetailRewardAdHoc.vue?vue&type=template&id=36468672"
import script from "./HistoryDetailRewardAdHoc.vue?vue&type=script&lang=js"
export * from "./HistoryDetailRewardAdHoc.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetailRewardAdHoc.vue?vue&type=style&index=0&id=36468672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports